import { type CommonAction, response } from "@iflyrpa/share";
import { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { Http } from "../../utils/http";
import { rid } from "../../utils/shipinhao/utils";

export interface ShipinhaoGetMsgImageParams extends ActiomCommonParams {
    imgMsg: {
        aeskey: string;
        url: string;
    };
    rawContent: string;
}

// 图片信息响应数据结构
export interface MediaInfoResponse {
    errCode: number;
    errMsg: string;
    data?: {
        baseResp?: {
            errcode: number;
        };
        imgContent?: string; // base64 编码的图片内容（无头）
        length?: string;
        ext?: string; // 图片扩展名，如 png、jpeg 等
    };
}

export type ShipinhaoGetMediaInfoAction = CommonAction<
    ShipinhaoGetMsgImageParams,
    {
        base64Img: string;
    }
>;

export const shipinhaoGetMsgImage: ShipinhaoGetMediaInfoAction = async (_task, params) => {
    try {
        // 验证 cookies
        if (!params.cookies?.length) {
            return response(414, "视频号获取媒体信息失败：缺少必需的 cookies 参数", {
                base64Img: "",
            });
        }

        const { extraParam, imgMsg, rawContent } = params;
        if (!extraParam?.fingerPrintDeviceId || !extraParam?.aId || !extraParam?.uin) {
            return response(414, "fingerPrintDeviceId、aId和uin不能为空", {
                base64Img: "",
            });
        }

        const finderUserName = extraParam.finderUserName;
        if (!finderUserName) {
            return response(414, "缺少 finderUserName 参数", {
                base64Img: "",
            });
        }

        const cookieStr = params.cookies.map((it) => `${it.name}=${it.value}`).join(";");

        const headers = {
            referer: "https://channels.weixin.qq.com/micro/interaction/private_msg",
            cookie: cookieStr,
            Origin: "https://channels.weixin.qq.com",
            Accept: "*/*",
            "Accept-Language": "zh-CN,zh;q=0.9,en-US;q=0.8,en;q=0.7",
            "Content-Type": "application/json",
            "X-WECHAT-UIN": extraParam.uin,
            "finger-print-device-id": extraParam.fingerPrintDeviceId,
            "Sec-Fetch-Dest": "empty",
            "Sec-Fetch-Mode": "cors",
            "Sec-Fetch-Site": "same-origin",
        };

        const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];
        const http = new Http(...args);

        const mediaInfoRes = await http.api<MediaInfoResponse>(
            {
                method: "post",
                url: `https://channels.weixin.qq.com/micro/interaction/cgi-bin/mmfinderassistant-bin/private-msg/get-media-info?_aid=${extraParam.aId}&_rid=${rid()}&_pageUrl=https:%2F%2Fchannels.weixin.qq.com%2Fmicro%2Finteraction%2Fprivate_msg`,
                data: {
                    mediaType: 3, // 图片类型固定为3
                    imgMsg: imgMsg,
                    rawContent: rawContent,
                    timestamp: Date.now().toString(),
                    _log_finder_uin: null,
                    _log_finder_id: finderUserName,
                    rawKeyBuff: null,
                    pluginSessionId: null,
                    scene: 7,
                    reqScene: 7,
                },
                headers,
            },
            { retries: 3, retryDelay: 20, timeout: 5000 },
        );

        console.log("媒体信息响应", JSON.stringify(mediaInfoRes));

        if (mediaInfoRes?.errCode !== 0 || !mediaInfoRes.data?.imgContent) {
            return response(414, `视频号获取媒体信息失败: ${mediaInfoRes?.errMsg || "未知错误"}`, {
                base64Img: "",
            });
        }

        const extMap: Record<string, string> = {
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            webp: "image/webp",
            bmp: "image/bmp",
            svg: "image/svg+xml",
        };

        const normalizedExt = mediaInfoRes.data?.ext?.toLowerCase().replace(/^\./, "");
        const mimeType = extMap[normalizedExt || ""] || "image/png"; // 默认使用 png
        const base64Img = `data:${mimeType};base64,${mediaInfoRes.data?.imgContent}`;

        const data = {
            base64Img,
        };

        console.log("媒体信息处理结果", JSON.stringify(data));

        return response(0, `视频号获取媒体信息成功${_task.debug ? ` ${http.proxyInfo}` : ""}`, data);
    } catch (error) {
        console.error("获取媒体信息异常", error);
        return response(414, `获取媒体信息异常: ${error}`, {
            base64Img: "",
        });
    }
};
